import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { WEBAPP_ROUTE_PREFIX } from '../../../../constants/route'
import { LOCAL_STORAGE_NAME_TOKEN } from '../../../../constants/storage'
import { useInitData, useRootPath } from '../../../../hooks'
import { removeStorageItem } from '../../../../utils/storage'

import { isSameBaseDomainRedirectUrl } from './useAuthRedirectLoggedUser.utils'

export function useAuthRedirectLoggedUser() {
  const navigate = useNavigate()

  const { hasRedirectParam, rootPath } = useRootPath()

  const { authorized } = useInitData()

  useEffect(() => {
    if (!authorized) {
      removeStorageItem(LOCAL_STORAGE_NAME_TOKEN)
    } else if (
      (hasRedirectParam && isSameBaseDomainRedirectUrl(rootPath)) ||
      rootPath.includes(WEBAPP_ROUTE_PREFIX)
    ) {
      window.location.replace(rootPath)
    } else {
      navigate(rootPath, { replace: true })
    }
  }, [authorized])
}
